import React from "react";
import { Route, Redirect } from "react-router-dom";
import Path from "../enums/path";

const AuthorizedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return localStorage.getItem("accessToken") ? (
          <Component {...props} />
        ) : (
          <Redirect to={`${Path.Auth}`} />
        );
      }}
    />
  );
};

export default AuthorizedRoute;
